import { useForm } from "../../../provider/Form/FormProvider";
import Grid from "@mui/material/Grid";
import { dateFieldDefault, requiredValidator } from "../../../services/validationRules";
import React from "react";
import FormLegend from "../Common/FormLegend/FormLegend";
import ValidatorDateField from "../../FormFields/ValidatorDateField";
import { translate } from "../../../services/translations/translations";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type DefenseProcessBaseDataProps = {
  product: AbstractCase;
};

export default function DefenseProcessBaseData({ product }: DefenseProcessBaseDataProps) {
  const { values } = useForm();

  return (
    <>
      {values.defenseProcessStatus === "paymentOrder" && (
        <>
          <Grid size={12}>
            <FormLegend>{translate(`${product.name}.paymentOrderDate.question`, values)}</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorDateField
              name="paymentOrderDate"
              label={translate(`${product.name}.paymentOrderDate.label`, values)}
              helperText={translate(`${product.name}.paymentOrderDate.helperText`, values)}
              validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault]}
            />
          </Grid>
        </>
      )}
      {values.defenseProcessStatus === "enforcementOrder" && (
        <>
          <Grid size={12}>
            <FormLegend>{translate(`${product.name}.enforcementOrderDate.question`, values)}</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorDateField
              name="enforcementOrderDate"
              label={translate(`${product.name}.enforcementOrderDate.label`, values)}
              helperText={translate(`${product.name}.enforcementOrderDate.helperText`, values)}
              validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault]}
            />
          </Grid>
        </>
      )}
      {values.defenseProcessStatus === "lawsuit" && (
        <>
          <Grid size={12}>
            <FormLegend>{translate(`${product.name}.statementOfClaimFiledDate.question`, values)}</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorDateField
              name="statementOfClaimFiledDate"
              label={translate(`${product.name}.statementOfClaimFiledDate.label`, values)}
              helperText={translate(`${product.name}.statementOfClaimFiledDate.helperText`, values)}
              validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault]}
            />
          </Grid>
        </>
      )}
    </>
  );
}
